module.exports = __webpack_public_path__ + "static/media/romeo-and-juliet.19c20525.gif";